import { useEffect, useState } from "react";

/**
 * Guard-rail unico per tutti i motion layer premium della landing.
 * - reduced: true se l'utente ha attivato prefers-reduced-motion
 * - coarse:  true su dispositivi touch (pointer: coarse)
 * - disabled: reduced || coarse  → disattiva effetti dipendenti dal puntatore
 *
 * Nota: la scroll progress bar e il timeline-fill NON dipendono dal puntatore,
 * quindi rispettano solo `reduced`.
 */
export default function useMotionGuard() {
    const [reduced, setReduced] = useState(false);
    const [coarse, setCoarse] = useState(false);

    useEffect(() => {
        if (typeof window === "undefined" || !window.matchMedia) return;
        const mReduce = window.matchMedia("(prefers-reduced-motion: reduce)");
        const mCoarse = window.matchMedia("(pointer: coarse)");

        const update = () => {
            setReduced(mReduce.matches);
            setCoarse(mCoarse.matches);
        };
        update();

        const add = (m, fn) => (m.addEventListener ? m.addEventListener("change", fn) : m.addListener(fn));
        const rem = (m, fn) => (m.removeEventListener ? m.removeEventListener("change", fn) : m.removeListener(fn));

        add(mReduce, update);
        add(mCoarse, update);
        return () => {
            rem(mReduce, update);
            rem(mCoarse, update);
        };
    }, []);

    return { reduced, coarse, disabled: reduced || coarse };
}
